import React from 'react';
import { getClass } from "../../../utils/component-helpers";

import './strategy-selection.scss';

const StrategySelection = (
	{
		strategyType,
		selectStrategyType,
		strategyValueInput,
		updateStrategyValue,
		validateStrategyInput,
		pricingModel,
		hasError,
	}
) => {
	const errorMessage = hasError ? (
		<div className="error-label">
			{`Invalid ${strategyType.toUpperCase()}`}
		</div>
	) : null;

	return (
		<div className="strategy-selection-container">
			<div className="strategy-label">Strategy</div>
			<div
				className={getClass('roi-strategy', {
					'selected': strategyType === 'roi',
					'show': pricingModel === 'EPP',
				})}
				onClick={() => selectStrategyType('roi')}>
				ROI
			</div>
			<div
				className={getClass('cpc-strategy', {
					'selected': strategyType === 'cpc',
				})}
				onClick={() => selectStrategyType('cpc')}>
				CPC
			</div>
			<div className="is">is</div>
			<input
				className={`strategy-value-input${hasError ? ' error' : ''}`}
				placeholder={`Set ${strategyType.toUpperCase()}`}
				value={strategyValueInput}
				onChange={(event) => updateStrategyValue(event)}
				onBlur={() => validateStrategyInput(strategyValueInput)}
			/>
			{errorMessage}
		</div>
	);
};

export default StrategySelection;
